import { IEventDetailedRound } from '../../eventRounds/store';

import api, { request } from '../../../../api';
import { IStore } from '../../../';

export const getRound = async (state: IStore, clubId: number, eventId: number, roundId: number) => {
  const response = await request.get(`${api.admin.events(clubId)}${eventId}/rounds/${roundId}/`);

  if (response.error) {
    return { errors: { events: { msg: 'Error retrieving the Event Round.' } } };
  }

  const event = state.adminEvents[eventId];

  const newRound: IEventDetailedRound = response;
  return {
    adminEvents: {
      [eventId]: {
        ...event,
        rounds: event.rounds.filter(round => round.id !== roundId).concat([newRound])
      }
    }
  };
};
